import React, {Component} from 'react';
import {connect} from "react-redux";
import classes from './Landing.module.css';
import DatePicker from 'react-date-picker';
import {addToCart} from "../../store/actions/cart";
import {getPortalSettings} from "../../store/actions/portalSettings";
import Carousel from "../Carousel/Carousel";
import {FaCheck} from "react-icons/fa";


class Landing extends Component {

    state = {
        gift: false,
        toFirstName: '',
        toLastName: '',
        toNickName: '',
        fromEmail: '',
        toEmail: '',
        personalMessage: '',
        amountSelected: "25",
        otherAmount: 0,
        sendNow: true,
        date: new Date(),
        hour: 12,
        timezone: '-05:00',
        amPm: 'pm',
        cartPopupShown: false,
        accountName: ''
    };

    componentDidMount() {

        const subdomainAccountId = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
        console.log("domain ", subdomainAccountId);
        this.setState({
            ...this.state,
            accountName: subdomainAccountId
        });
        if (!this.props.portalSettings) {
            this.props.getPortalSettings(subdomainAccountId)
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.portalSettings && this.props.portalSettings) {
            console.log("Portal Settings: ", this.props.portalSettings)
        }
        console.log("previous state cart items length, ", prevProps.cartItems.length)
        console.log("current state cart items length, ", this.props.cartItems.length)


        if (prevProps.cartItems.length === 0 && this.props.cartItems.length > 0) {
            console.log("Cart IS empty and length changed, showing popup")
            this.setState({
                ...this.state,
                cartPopupShown: true
            })
        } else if (prevProps.cartItems.length < this.props.cartItems.length) {
            console.log("Cart IS NOT empty and length changed, showing popup")
            this.setState({
                ...this.state,
                cartPopupShown: true
            })
        }
    }

    submit() {
        if (this.state.gift) {
            if (!this.state.toEmail || !this.state.fromEmail || !this.state.toFirstName || !this.state.toLastName) {
                return
            }
        }

        let designUrl = localStorage.getItem('designUrl')

        let cartItemId;

        if (this.props.cartItems && this.props.cartItems.length > 0) {
            cartItemId = this.props.cartItems.length + 1;
        } else {
            cartItemId = 1
        }

        let item = {
            id: cartItemId,
            gift: this.state.gift,
            amountSelected: this.state.amountSelected,
            otherAmount: this.state.otherAmount,
            sendNow: this.state.sendNow,
            date: this.state.date,
            hour:this.state.hour,
            amPm: this.state.amPm,
            timezone: this.state.timezone,
            designUrl: designUrl,
            toFirstName: this.state.toFirstName,
            toLastName: this.state.toLastName,
            toNickName: this.state.toNickName,
            fromEmail: this.state.fromEmail,
            toEmail: this.state.toEmail,
            personalMessage: this.state.personalMessage,
            accountName: this.state.accountName
        };
        this.props.addToCart(item)
    }

    changeAmounts(option) {
        this.setState({
            ...this.state,
            amountSelected: option
        })
    }

    changeGift(isAGift) {
        this.setState({
            ...this.state,
            gift: isAGift
        })
    }

    changeDelivery(sendNow) {
        this.setState({
            ...this.state,
            sendNow: sendNow
        })
    }

    handleContinueShoppingClick() {
        this.setState({
            ...this.state,
            cartPopupShown: false
        })
    }

    handleCustomDollarAmount(e) {
        e.preventDefault();
        console.log(e.target.value)
        if (e.target.value === "$") {
            e.target.value = null
            this.setState({
                ...this.state,
                otherAmount: null,
                amountSelected: "25"
            })
        } else {
            this.setState({
                ...this.state,
                otherAmount: e.target.value,
                amountSelected: null
            })
        }
    }

    isNumeric(str) {
        if (typeof str != "string") return false // we only process strings!
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }

    handleDateSelect(date) {
        this.setState({
            ...this.state,
            date: date
        })
    }

    getDesignImages() {
        let designList = []
        const portalGraphics = this.props.portalSettings.cardGraphics
        portalGraphics.forEach((graphicUrl) => {
            designList.push({type: 'image', url: graphicUrl})
        });
        return designList
    }


    changeToFirstName(e) {
        this.setState({
            ...this.state,
            toFirstName: e.target.value
        })
    }

    changeToLastName(e) {
        this.setState({
            ...this.state,
            toLastName: e.target.value
        })
    }

    changeToNickName(e) {
        this.setState({
            ...this.state,
            toNickName: e.target.value
        })
    }

    changeFromEmail(e) {
        this.setState({
            ...this.state,
            fromEmail: e.target.value
        })
    }

    changeToEmail(e) {
        this.setState({
            ...this.state,
            toEmail: e.target.value
        })
    }

    changePersonalMessage(e) {
        this.setState({
            ...this.state,
            personalMessage: e.target.value
        })
    }

    handleHourChange(e) {
        this.setState({
            ...this.state,
            hour: e.target.value
        })
    }


    handleTimeZoneChange(e){
        this.setState({
            ...this.state,
            timezone: e.target.value
        })
    }

    handleAmPmChange(e){
        this.setState({
            ...this.state,
            amPm: e.target.value
        })
    }

    render() {
        let portalSettings = this.props.portalSettings;

        if (!portalSettings) {
            return null
        }
        let mainLogoUrl = portalSettings.mainLogoUrl
        let pageBackgroundImage;
        let pageBackgroundColorCode;
        if (portalSettings.pageBody.background.imageUrl) {
            pageBackgroundImage = portalSettings.pageBody.background.imageUrl
        } else {
            pageBackgroundColorCode = portalSettings.pageBody.background.colorCode
        }
        let pageBackground;
        if (pageBackgroundColorCode) {
            pageBackground = {
                backgroundColor: pageBackgroundColorCode
            }
        } else if (pageBackgroundImage) {
            pageBackground = {
                backgroundImage: pageBackgroundImage

            }
        }


        let colorModel = portalSettings.pageBody.colorModel
        let mainColors = {
            backgroundColor: colorModel.mainColorCode,
            color: colorModel.mainTextColorCode

        };
        let accentColors = {
            backgroundColor: colorModel.accentColorCode,
            color: colorModel.accentTextColorCode,
            borderBottom: `6px solid ${colorModel.mainColorCode}`
        };
        let dividerColor = {
            borderBottom: `2px solid ${colorModel.dividerColorCode}`
        };

        let addToCartButtonColors = {
            backgroundColor: colorModel.addToCartBackgroundColor,
            color: colorModel.addToCartFontColor
        };

        let popupButtonColors = {
            backgroundColor: colorModel.popupButtonBackgroundColor,
            color: colorModel.popupButtonFontColor
        }

        console.log("cart ", this.props.cart);
        return (

            <div style={pageBackground} className={classes.root}>

                {this.state.cartPopupShown ?
                    <div className={classes.popupCartBox}>
                        <div className={classes.popupCartTextBox}>
                            <div><FaCheck size="2em"/></div>
                            <div className={classes.popupHeaderText}>
                                Item has been added to your cart!
                            </div>
                        </div>
                        <div className={classes.popupButtonsRow}>
                            <div
                                onClick={(e) => {
                                    this.handleContinueShoppingClick()
                                }}
                                style={popupButtonColors}
                                className={classes.popupButton}>
                                Continue Shopping
                            </div>
                            <div
                                onClick={() => this.props.history.push('/cart')}
                                style={popupButtonColors}
                                className={classes.popupButton}>
                                Go To Cart
                            </div>
                        </div>
                    </div>
                    : null
                }

                <div className={classes.sticky}>
                    <div className={classes.rightBarContainer}>
                        <div className={classes.rightTitle}> Choose a Design</div>
                        <div className={classes.cardDesignBox}>

                            {/*  <img src={Card} alt={"card"}/>*/}

                            <Carousel
                                data={
                                    this.getDesignImages()
                                }
                            />
                        </div>

                        {/*   <div className={classes.changeButtonRow}>
                            <button className={classes.changeCardButton}>CHANGE</button>
                        </div>*/}

                        {/*   <div className={classes.totalsBox}>
                            <div className={classes.totalRow}>
                                Subtotal:
                            </div>
                            <div className={classes.totalRow}>
                                Tax:
                            </div>
                        </div>*/}
                    </div>
                </div>

                <div className={classes.logoContainer}>
                    <div className={classes.logo}>
                        <img width={250} src={mainLogoUrl} alt={"logo"}/>
                    </div>
                </div>

                <div className={classes.bodyContainer}>

                    <div className={classes.formContainer}>
                        <div className={classes.form}>

                            <div className={classes.checkoutStep}>
                                <div
                                    style={mainColors}
                                    className={classes.description}>
                                    1. Amount
                                </div>
                                <div className={classes.formFieldRow}>
                                    <div id={"25"}
                                         onClick={(e) => {
                                             this.changeAmounts("25")
                                         }}
                                         style={this.state.amountSelected === "25" ? accentColors : mainColors}
                                         className={` ${this.state.amountSelected === "25" ? classes.selectedOption : null} ${classes.amountBox}`}>
                                        $25.00
                                    </div>
                                    <div
                                        onClick={(e) => {
                                            this.changeAmounts("50")
                                        }}
                                        style={this.state.amountSelected === "50" ? accentColors : mainColors}
                                        className={` ${this.state.amountSelected === "50" ? classes.selectedOption : null} ${classes.amountBox}`}>
                                        $50.00
                                    </div>
                                    <div onClick={(e) => {
                                        this.changeAmounts("75")
                                    }}
                                         style={this.state.amountSelected === "75" ? accentColors : mainColors}
                                         className={` ${this.state.amountSelected === "75" ? classes.selectedOption : null} ${classes.amountBox}`}>
                                        $75.00
                                    </div>
                                    <div onClick={(e) => {
                                        this.changeAmounts("100")
                                    }}
                                         style={this.state.amountSelected === "100" ? accentColors : mainColors}
                                         className={` ${this.state.amountSelected === "100" ? classes.selectedOption : null} ${classes.amountBox}`}>
                                        $100.00
                                    </div>
                                    <div onClick={(e) => {
                                        this.changeAmounts("150")
                                    }}
                                         style={this.state.amountSelected === "150" ? accentColors : mainColors}
                                         className={` ${this.state.amountSelected === "150" ? classes.selectedOption : null} ${classes.amountBox}`}>
                                        $150.00
                                    </div>
                                    {/*      <div className={classes.otherAmountContainer}>
                                        <input type="text"
                                               placeholder={"Other Amount ($10.00 - $250.00 increments of $1.00)"}
                                               className={classes.otherAmountInput}
                                               onChange={(e) => this.handleCustomDollarAmount(e)}
                                               value={this.state.otherAmount > 0 ? "$" + this.state.otherAmount : null}

                                        />
                                    </div>*/}
                                </div>
                            </div>
                            <div style={dividerColor} className={classes.descriptionDivider}/>
                            <div className={classes.checkoutStep}>
                                <div
                                    style={mainColors}
                                    className={classes.description}>
                                    2. Personalize <span className={classes.descriptionSubtitle}>(Go ahead, tell ‘em how you really feel.)</span>
                                </div>
                                <div className={`${classes.formFieldRow} ${classes.secondStepContainer}`}>
                                    <div className={classes.twoColumnRow}>
                                        <div
                                            onClick={(e) => {
                                                this.changeGift(false)
                                            }}
                                            style={!this.state.gift ? accentColors : mainColors}
                                            className={`${!this.state.gift ? classes.selectedOption : null} ${classes.selectableButton}`}>
                                            THIS IS FOR ME
                                        </div>
                                        <div
                                            onClick={(e) => {
                                                this.changeGift(true)
                                            }}
                                            style={this.state.gift ? accentColors : mainColors}
                                            className={`${this.state.gift ? classes.selectedOption : null} ${classes.selectableButton}`}>THIS
                                            IS A GIFT
                                        </div>

                                    </div>

                                    {
                                        this.state.gift ?
                                            <div className={classes.giftInfoColumnsRow}>
                                                <div className={classes.isGiftInfoColumn}>
                                                    <div className={classes.giftInfoRow}>
                                                        <div className={classes.nameInputBox}>
                                                            <input
                                                                onChange={(e) => this.changeToFirstName(e)}
                                                                value={this.state.toFirstName}
                                                                className={classes.toName} type="text"
                                                                placeholder="To (First Name)"/>
                                                        </div>
                                                        <div className={classes.nameInputBox}>
                                                            <input
                                                                onChange={(e) => this.changeToLastName(e)}
                                                                value={this.state.toLastName}
                                                                className={classes.toName} type="text"
                                                                placeholder="To (Last Name)"/>
                                                        </div>
                                                    </div>

                                                    <div className={classes.giftInfoRow}>
                                                        <div className={classes.nameInputBox}>
                                                            <input
                                                                onChange={(e) => this.changeToNickName(e)}
                                                                value={this.state.toNickName}
                                                                className={classes.giftInfoField} type="text"
                                                                placeholder="To (Nickname)"/>
                                                        </div>
                                                    </div>

                                                    <div className={classes.giftInfoRow}>
                                                        <div className={classes.nameInputBox}>
                                                            <input
                                                                onChange={(e) => this.changeFromEmail(e)}
                                                                value={this.state.fromEmail}
                                                                className={classes.giftInfoField} type="text"
                                                                placeholder="From (Email) *"/>
                                                        </div>
                                                    </div>
                                                    <div className={classes.giftInfoRow}>
                                                        <div className={classes.nameInputBox}>
                                                            <input
                                                                onChange={(e) => this.changeToEmail(e)}
                                                                value={this.state.toEmail}
                                                                className={classes.giftInfoField} type="text"
                                                                placeholder="Recipient email *"/>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className={classes.isGiftInfoColumn}>
                                                    <div className={classes.giftInfoRow}>
                                                        <div className={classes.nameInputBox}>
                                                            <textarea
                                                                onChange={(e) => this.changePersonalMessage(e)}
                                                                value={this.state.personalMessage}
                                                                className={classes.personalMessageInput}
                                                                placeholder="Add a personal message line:"/>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            :
                                            null
                                    }


                                </div>
                            </div>
                            <div style={dividerColor} className={classes.descriptionDivider}/>
                            <div className={classes.checkoutStep}>
                                <div
                                    style={mainColors}
                                    className={classes.description}>
                                    3.) Schedule Delivery
                                </div>
                                <div className={`${classes.formFieldRow} ${classes.secondStepContainer}`}>
                                    <div className={classes.twoColumnRow}>
                                        <div
                                            onClick={(e) => {
                                                this.changeDelivery(true)
                                            }}
                                            style={this.state.sendNow ? accentColors : mainColors}
                                            className={`${this.state.sendNow ? classes.selectedOption : null} ${classes.selectableButton}`}>
                                            SEND NOW
                                        </div>
                                        <div
                                            onClick={(e) => {
                                                this.changeDelivery(false)
                                            }}
                                            style={!this.state.sendNow ? accentColors : mainColors}
                                            className={`${!this.state.sendNow ? classes.selectedOption : null} ${classes.selectableButton}`}>
                                            SEND LATER
                                        </div>
                                    </div>

                                    {
                                        !this.state.sendNow ?
                                            <div className={classes.giftInfoColumnsRow}>

                                                <div className={classes.isGiftInfoColumn}>

                                                </div>

                                                <div className={classes.isGiftInfoColumn}>
                                                    <div className={classes.giftInfoRow}>
                                                        <div className={classes.timeInputBox}>
                                                            <div id="picker" className={classes.datePick}>
                                                                <DatePicker
                                                                    onChange={(e) => this.handleDateSelect(e)}
                                                                    value={this.state.date}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={classes.dateTimeRow}>
                                                        <div className={classes.timeInputBox}>
                                                            <input className={classes.timeSelectInputs}
                                                                   type="number"
                                                                   min={1}
                                                                   max={12}
                                                                   placeholder="Hour of Day"
                                                                   value={this.state.hour}
                                                                   onChange={(e) => this.handleHourChange(e)}
                                                            />
                                                        </div>
                                                        <div className={classes.timeInputBox}>
                                                            <select className={classes.timeSelectInputs}
                                                                    name="ampm"
                                                                    id="ampm"
                                                                    value={this.state.amPm}
                                                                    onChange={(e) => this.handleAmPmChange(e)}

                                                            >
                                                                <option value="am">AM</option>
                                                                <option value="pm">PM</option>
                                                            </select>
                                                        </div>
                                                        <div className={classes.timeInputBox}>
                                                            <select name="time_zone" id="time_zone"
                                                                    className={classes.timeSelectInputs}
                                                                    value={this.state.timezone}
                                                                    onChange={(e) => this.handleTimeZoneChange(e)}
                                                            >

                                                                <option value="-05:00">Eastern Time</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            :
                                            null
                                    }


                                </div>
                            </div>
                            <div style={dividerColor} className={classes.descriptionDivider}/>
                            <div className={classes.addToCartRow}>
                                <button
                                    style={addToCartButtonColors}
                                    className={classes.cartButton} onClick={() => this.submit()}
                                    type="submit">ADD TO CART
                                </button>
                            </div>
                        </div>

                    </div>


                </div>


            </div>
        )

    }
}

const mapStateToProps = state => ({
    cartItems: state.cartReducer.cart,
    portalSettings: state.portalSettingsReducer.portalSettings
});

const mapDispatchToProps = dispatch => ({
    addToCart: (item) => dispatch(addToCart(item)),
    getPortalSettings: (accountId) => dispatch(getPortalSettings(accountId))
});

export default connect(mapStateToProps, mapDispatchToProps)(Landing);